import React from "react";
import { Form } from "react-bootstrap";
import { Button } from "reactstrap";
import { Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { getAdminLogsData } from "../../services/commonService";
import { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import moment from "moment";
import right_arrow from "../../assets/images/icon/right-arrow-table.svg";
import serach_icon from "../../assets/images/icon/search-icon.svg";
import dowanload_csv from "../../assets/images/icon/downloadcsv.svg";
import { decryptDataFromArray } from "helpers/EncDec";
import { generateMaskedPII, getCompanyTimezoneDateTime, checkPermissionStatus } from "helpers/utils";
import { useTranslation } from "react-i18next";

function AdminLogs(props) {
  const { t } = useTranslation();
  const [adminLogData, setadminLogData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [isDownloading, setIsDownloading] = useState(false);

  //tabs
  const [activeTab, setActiveTab] = useState("tab1");
  const handleTabClick = tab => {
    setActiveTab(tab);
  };

  const buildParams = (page, limit, overrides = {}) => ({
    page,
    limit,
    ...(searchText && { search: searchText }),
    ...(fromDate && { from_date: fromDate }),
    ...(toDate && { to_date: toDate }),
    ...overrides,
  });

  const fetchLogs = (page = 1, limit = 10, overrides = {}) => {
    const params = buildParams(page, limit, overrides);
    getAdminLogsData(params)
      .then(res => {
        let responseData = res?.data;
        responseData = decryptDataFromArray(responseData);

        if (responseData?.status) {
          setadminLogData(responseData?.data);
          setTotalCount(responseData?.total || responseData?.total_counts || 0);
        } else {
          toast.error(t(`Admin Logs.No data available`));
        }
      })
      .catch(() => {
        toast.error(t(`Admin Logs.No data available`));
      });
  };

  useEffect(() => {
    fetchLogs(currentPage, sizePerPage);
  }, []);

  const handleSearch = e => {
    const value = e.target.value;
    setSearchText(value);
    setCurrentPage(1);
    fetchLogs(1, sizePerPage, { search: value });
  };

  const handleApply = () => {
    setCurrentPage(1);
    fetchLogs(1, sizePerPage);
  };

  const handleReset = () => {
    setSearchText("");
    setFromDate("");
    setToDate("");
    setCurrentPage(1);
    getAdminLogsData({ page: 1, limit: sizePerPage })
      .then(res => {
        let responseData = res?.data;
        responseData = decryptDataFromArray(responseData);
        if (responseData?.status) {
          setadminLogData(responseData?.data);
          setTotalCount(responseData?.total || responseData?.total_counts || 0);
        }
      })
      .catch(() => {});
  };

  const handleTableChange = (type, { page, sizePerPage: newSize }) => {
    setCurrentPage(page);
    setSizePerPage(newSize);
    fetchLogs(page, newSize);
  };

  const handleDownload = () => {
    setIsDownloading(true);
    const params = buildParams(1, 100000);
    getAdminLogsData(params)
      .then(res => {
        let responseData = res?.data;
        responseData = decryptDataFromArray(responseData);
        if (responseData?.status) {
          const data = responseData?.data || [];
          if (data.length === 0) {
            toast.error("No data available to download");
            return;
          }
          const headers = ["Name", "Email", "Role", "IP Address", "Browser", "Login Time", "Logout Time"];
          const rows = data.map(row => [
            row?.user?.name || "-",
            row?.user?.email || "-",
            row?.user?.role?.name || "-",
            row?.ip_address || "-",
            row?.browser || "-",
            row?.login_time
              ? moment(getCompanyTimezoneDateTime(row.login_time)).format("DD MMM YYYY hh:mm:ss a")
              : "-",
            row?.logout_time
              ? moment(getCompanyTimezoneDateTime(row.logout_time)).format("DD MMM YYYY hh:mm:ss a")
              : "-",
          ]);
          const csvContent = [headers, ...rows]
            .map(r => r.map(cell => `"${String(cell).replace(/"/g, '""')}"`).join(","))
            .join("\n");
          const blob = new Blob(["\uFEFF" + csvContent], { type: "text/csv;charset=utf-8;" });
          const url = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = `AdminLogs_${moment().format("YYYYMMDD_HHmmss")}.csv`;
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          setTimeout(() => {
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
          }, 500);
          toast.success(`Downloaded ${data.length} records successfully`);
        } else {
          toast.error("No data available");
        }
      })
      .catch(() => {
        toast.error("Download failed");
      })
      .finally(() => {
        setIsDownloading(false);
      });
  };

  // Bootstrap table columns
  const handleCheck = (e, app_id) => {
    let value = e.target.checked;
    let alladminLogs = adminLogData?.map(el => {
      if (el?.log_id === app_id) {
        el.checked = value;
      }
      return el;
    });
    setadminLogData(alladminLogs);
  };

  const columns = [
    {
      dataField: "user.name",
      text: t(`Admin Logs.Name`),
      classes: "text-center",
      headerClasses: "text-center",
      formatter: (cell, row) => <>{row?.user?.name || "-"}</>,
    },
    {
      dataField: "user.email",
      text: t(`Admin Logs.Email`),
      classes: "text-center",
      headerClasses: "text-center",
      formatter: (cell, row) => <>{generateMaskedPII(row?.user?.email)}</>,
    },
    {
      dataField: "user.role.name",
      text: t(`Admin Logs.Role`),
      classes: "text-center",
      headerClasses: "text-center",
      formatter: (cell, row) => <>{row?.user?.role?.name || "-"}</>,
    },
    {
      dataField: "ip_address",
      text: t(`Admin Logs.IP Address`),
      classes: "text-center",
      headerClasses: "text-center",
    },
    {
      dataField: "browser",
      text: t(`Admin Logs.Browser`),
      classes: "text-center",
      headerClasses: "text-center",
    },
    {
      dataField: "login_time",
      text: t(`Admin Logs.Login Time`),
      classes: "text-center",
      headerClasses: "text-center",
      formatter: cell => {
        return moment(getCompanyTimezoneDateTime(cell))?.format(
          "DD MMM YYYY hh:mm:ss a"
        );
      },
    },
    {
      dataField: "logout_time",
      text: t(`Admin Logs.Logout Time`),
      classes: "text-center",
      headerClasses: "text-center",
      formatter: (cellContent, row) => (
        <>
          {row?.logout_time == null
            ? ""
            : moment(getCompanyTimezoneDateTime(cellContent))?.format(
                "DD MMM YYYY hh:mm:ss a"
              )}
        </>
      ),
    },
  ];
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {t(`Admin Logs.Showing rows`, { from, to, size })}
    </span>
  );
  let options = {
    paginationSize: 1,
    pageStartIndex: 1,
    page: currentPage,
    sizePerPage: sizePerPage,
    totalSize: totalCount,
    alwaysShowAllBtns: true,
    withFirstAndLast: true,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    firstPageText: false,
    prePageText: false,
    nextPageText: false,
    lastPageText: false,
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: false,
  };
  // Delete Faqs
  const handleCookieRecords = log_id => {
    DeleteCookieRecord(log_id)
      .then(res => {
        if (res.status == 200) {
          let messages = toast.success(
            t(`Admin Logs.Record deleted successfully`)
          );
          window.location.reload();
        } else {
          toast.error(res?.data?.message);
          ref.current?.scrollIntoView({ behavior: "smooth" });
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  //rohit-code//

  const rowClasses = (row, rowIndex) => {
    return rowIndex % 2 === 0 ? "even-row" : "odd-row";
  };

  /**table arrow */
  const tableWrapperRef = useRef(null);
  const handleScroll = direction => {
    if (tableWrapperRef.current) {
      const scrollAmount = 100; // Adjust this value as needed
      tableWrapperRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);

  return (
    <>
      <div className="outerTab-box-wrapper below-vacancy amsterresign applicationcard-table pt-4">
        <div className="franchise-list-page">
          <div className="tab-content" id="pills-tabContent">
            <div
              className="tab-pane fade show active"
              id="pills-home"
              role="tabpanel"
              // aria-labelledby="pills-home-tab"
            >
              <div className="tabel-application table-responsive pb-3">
                <div className="tabel-franchise table-responsive pb-3">
                  <div className="table-data-search">
                    <div className="total-serachbar cookieslist flex-wrap gap-2">
                      {/* Row 1: filters */}
                      <div className="serach-bar-top">
                        <form className="form-inline">
                          <input
                            className="form-control mr-sm-2"
                            type="search"
                            placeholder={t(`Admin Logs.Search By`)}
                            aria-label="Search"
                            value={searchText}
                            onChange={handleSearch}
                            title={`Please enter ${t(
                              `Admin Logs.Search By`
                            ).toLowerCase()}`}
                          />
                          <span>
                            <img src={serach_icon} alt="search" />
                          </span>
                        </form>
                      </div>
                      <div className="serach-bar-top">
                        <Form.Control
                          type="date"
                          title={t(`Admin Logs.From Date`)}
                          value={fromDate}
                          onChange={e => setFromDate(e.target.value)}
                        />
                      </div>
                      <div className="serach-bar-top">
                        <Form.Control
                          type="date"
                          title={t(`Admin Logs.To Date`)}
                          value={toDate}
                          onChange={e => setToDate(e.target.value)}
                        />
                      </div>
                      <div className="serach-bar-top d-flex gap-2">
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={handleApply}
                        >
                          {t(`Admin Logs.Apply`)}
                        </button>
                        <button
                          className="btn btn-secondary btn-sm"
                          onClick={handleReset}
                        >
                          {t(`Admin Logs.Reset`)}
                        </button>
                      </div>
                      {/* Row 2: total records + download + scroll arrows */}
                      <div className="w-100 d-flex align-items-center justify-content-between mt-1">
                        <div className="d-flex align-items-center gap-3">
                          <div className="total-record mb-0">
                            <h5 className="mb-0">
                              {t(`Admin Logs.Total Records`)}:{" "}
                              <span>{totalCount || 0}</span>
                            </h5>
                          </div>
                          {checkPermissionStatus("admin-logs", "downloadcsv") && (
                            <div className="take-text">
                              <Button
                                color="info"
                                onClick={handleDownload}
                                outline
                                disabled={isDownloading}
                              >
                                <img src={dowanload_csv} alt="Download" />{" "}
                                {isDownloading ? "Downloading..." : "Download CSV"}
                              </Button>
                            </div>
                          )}
                        </div>
                        <div className="tale-text right-panel alapp arrow-btns">
                        <button
                          className="button left"
                          onClick={() => handleScroll("left")}
                          data-tooltip="Scroll Left"
                        >
                          <img src={right_arrow} alt="right-arrow" />
                        </button>
                        <button
                          className="button right"
                          onClick={() => handleScroll("right")}
                          data-tooltip="Scroll Right"
                        >
                          <img src={right_arrow} alt="right-arrow" />
                        </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="tabel-application table-responsive white-space-row  pb-3">
                    <div className="timeto-hire-card userlist">
                      <div className="table-custome-class range-custome">
                        <div className="scroll-container">
                          <div className="table-pending-list">
                            <div
                              className="table-wrapper"
                              ref={tableWrapperRef}
                            >
                              <BootstrapTable
                                keyField="id"
                                data={adminLogData}
                                columns={columns}
                                remote={{ pagination: true }}
                                pagination={paginationFactory(options)}
                                onTableChange={handleTableChange}
                                rowClasses={rowClasses}
                                hover
                                responsive
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminLogs;
